export default __webpack_public_path__ + "static/media/feature-a-2.f4b37004.jpg";